<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="关卡名称：">
            <el-input v-model="query.name" placeholder="请输入关卡名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="闯关模式：">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option label="考试闯关" :value="1"></el-option>
              <el-option label="学习闯关" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain>下载学员模板</el-button>
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['course:challenge:state']">批量启用</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['course:challenge:state']">批量禁用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['course:challenge:add']">新建关卡</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="关卡名称" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row,2)">{{row.name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="关卡介绍" prop="introduce" align="center" show-overflow-tooltip />
        <el-table-column label="闯关模式" prop="typeName" align="center" />
        <el-table-column label="闯关阶段" prop="stageCount" align="center">
          <template slot-scope="{row}">
            {{row.stageCount}}阶段
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.state" :active-value="1" :inactive-value="0" @change="changeSwitch(row)" v-hasPermi="['course:challenge:state']"></el-switch>
            {{row.state?'启用':'禁用'}}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作人" prop="operatedBy" align="center" />
        <el-table-column label="操作" align="center" fixed="right" width="260">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['course:challenge:edit']">编辑</el-button>
            <el-button type="text" @click="handleStudent(row)" v-hasPermi="['course:challenge:students']">闯关学员</el-button>
            <el-button type="text" @click="handleShow(row,3)" v-hasPermi="['course:challenge:stage']">闯关阶段</el-button>
            <el-dropdown @command="handleCommand1">
              <el-button type="text">更多<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-upload style="display: inline-block;margin:0 5px" :action="uploadImgUrl" :data="{id: row.id}" :show-file-list="false" :http-request="uploadFile" :file-list="fileList">
                  <el-dropdown-item :command="beforeHandleCommand1(row,2)" v-hasPermi="['course:challenge:import']">导入学员</el-dropdown-item>
                </el-upload>

                <el-dropdown-item :command="beforeHandleCommand1(row,3)" v-hasPermi="['course:challenge:duty']">值班老师</el-dropdown-item>
                <!-- <el-dropdown-item :command="beforeHandleCommand1(row,1)">日志记录</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <challenge-add ref="challengeAdd" @created="doQueryList({})" />
    <challenge-student ref="challengeStudent" />
    <rota-vue ref="rotaVue" />
  </div>
</template>

<script>
import challengeAdd from './add'
import courseSubjectBarrierApi from '@/api/course/courseSubjectBarrier'
import courseSubjectBarrierStudentApi from '@/api/course/courseSubjectBarrierStudent'
import Pagination from '@/components/Pagination'
import challengeStudent from './student.vue'
import rotaVue from './rota.vue'
import { getToken } from '@/utils/auth'

export default {
  components: {
    Pagination,
    challengeAdd,
    challengeStudent,
    rotaVue
  },
  data() {
    return {
      uploadImgUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload', // 上传的图片服务器地址
      headers: {
        Authorization: 'DU ' + getToken()
      },
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      activeName: '1'
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return courseSubjectBarrierApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectBarrierApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => courseSubjectBarrierApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '是否批量启用？' : '是否批量禁用？'
      this.$common.confirm(txt).then(() => courseSubjectBarrierApi.batchState({ idList: ids, state: type }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      courseSubjectBarrierApi.batchState({ idList: row.id, state: row.state }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    beforeHandleCommand1(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand1(command) {
      if (command.command === 1) {
        console.log('11111111')
      } else if (command.command === 2) {

      } else if (command.command === 3) {
        this.$refs.rotaVue.handleRota(command.row)
      }
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("barrierStageId", file.data.id);
      courseSubjectBarrierStudentApi.import(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    handleDownload() {
      courseSubjectBarrierStudentApi.downloadExcelTemplate2()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.challengeAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.challengeAdd.handleUpdate(row)
    },
    handleStudent(row) {
      this.$refs.challengeStudent.handleStudent(row)
    }
  }
}
</script>
